import { createContext, PropsWithChildren, useContext } from 'react';
import { useAuthSteps } from './useAuthSteps';

const AuthStepsContext = createContext<
    Pick<ReturnType<typeof useAuthSteps>, 'currentStep' | 'moveToNextStep'>
>({
    currentStep: 'auth',
    moveToNextStep: () => null
});

export const useAuthStepper = () => useContext(AuthStepsContext);

export const StepperStep = ({
    children,
    id
}: PropsWithChildren<{ id: string }>) => {
    const { currentStep } = useAuthStepper();

    if (id !== currentStep || !children) {
        return null;
    }

    // we need the fragment for TS to infer this is a JSX Element
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
};

export const AuthStepper = {
    Provider: AuthStepsContext.Provider,
    Step: StepperStep
};
